export default __webpack_public_path__ + "static/media/mission-statement.7a8ea45a.png";